import GestureAbstract from './abstract';

export default class GestureRotate extends GestureAbstract {
  init (mouse_x, mouse_y) {
    INKIVE.GestureAbstract.prototype.init.call(this, mouse_x, mouse_y);

    const that = this;
    const canvas = that.canvas;
    const selectedElements = canvas.getSelectedElems();
    canvas.runExtensions('startRotate', { elem: selectedElements[0] });

    this.rotateLimitReachedList = [];
    canvas.started = true;
  }

  update (r_mouse_x, r_mouse_y, event) {
    const shiftKey = event.shiftKey;
    const that = this;
    const canvas = that.canvas;
    const current_zoom = canvas.getZoom();

    r_mouse_x = r_mouse_x / current_zoom;
    r_mouse_y = r_mouse_y / current_zoom;

    const spanned = this.getSnappendCoordinates(r_mouse_x, r_mouse_y);
    const mouse_x = spanned[0];
    const mouse_y = spanned[1];

    const selectedElements = canvas.getSelectedElems();
    const selected = selectedElements[0];

    const center = getCenterPosition();
    let angle = getAngle();

    canvas.curConfig.gridSnapping && adjustToSnapGrid();
    shiftKey && adjustToNicerAngle();
    normalize();

    if ($(selected).hasClass('layoutClipperImage') && isEmptySpaceOnLayoutClipper()) {
      isTryingToRotateReallyHard.call(this) && canvas.call('advice.show', 'clipper-rotation-limit');
      return;
    }

    canvas.setRotationAngle(angle, true);

    function isTryingToRotateReallyHard () {
      const now = new Date();
      const aLotOfTries = 5;
      const oneMoveTime = 2000;

      const triesOnTime = _.reduce(
        this.rotateLimitReachedList,
        function (memo, tryTime) {
          const lapse = now - tryTime;
          return memo + (lapse > oneMoveTime ? 1 : 0);
        }, 1
      );

      this.rotateLimitReachedList.push(now);
      return triesOnTime > aLotOfTries;
    }

    function adjustToSnapGrid () {
      angle = svgedit.utilities.snapToGrid(angle);
    }

    function adjustToNicerAngle () {
      const snap = 45;
      angle = Math.round(angle / snap) * snap;
    }

    function normalize () {
      angle += angle < -360 ? 720 : 180;
    }

    function getCenterPosition () {
      const box = svgedit.utilities.getBBox(selected);
      const cx = box.x + box.width / 2;
      const cy = box.y + box.height / 2;
      const m = svgedit.math.getMatrix(selected);

      const center = svgedit.math.transformPoint(cx, cy, m);

      return { x: center.x, y: center.y };
    }

    function getAngle () {
      const atan = Math.atan2(center.y - mouse_y, center.x - mouse_x);
      const degrees = (atan * (180 / Math.PI)) - 90;

      return degrees % 360;
    }

    function isEmptySpaceOnLayoutClipper () {
      const layoutPosition = getLayoutCoords();
      const boxPosition = getBoxPosition();

      return isAnyPointOutsideRectangle([
        { x: layoutPosition.x, y: layoutPosition.y },
        { x: layoutPosition.x, y: layoutPosition.y + layoutPosition.height },
        { x: layoutPosition.x + layoutPosition.width, y: layoutPosition.y + layoutPosition.height },
        { x: layoutPosition.x + layoutPosition.width, y: layoutPosition.y }
      ], boxPosition);

      function getBoxPosition () {
        const box = svgedit.utilities.getBBox(selected);

        return {
          left: box.x,
          top: box.y,
          width: box.width,
          height: box.height
        };
      }

      function getLayoutCoords () {
        const imageCoordinades = selected.textContent.replace(/[^\d.-\s]/g, '').split(' ');

        return {
          x: parseFloat(imageCoordinades[0]),
          y: parseFloat(imageCoordinades[1]),
          width: parseFloat(imageCoordinades[2]),
          height: parseFloat(imageCoordinades[3])
        };
      }

      function isAnyPointOutsideRectangle (points, rectangle) {
        const radiansAngle = angle * Math.PI / 180;
        let rectangleArea = rectangle.width * rectangle.height;

        const pivot = {
          x: rectangle.left + rectangle.width / 2,
          y: rectangle.top + rectangle.height / 2
        };

        const rectangleOriginalVertices = [
          { x: rectangle.left, y: rectangle.top },
          { x: rectangle.left, y: rectangle.top + rectangle.height },
          { x: rectangle.left + rectangle.width, y: rectangle.top + rectangle.height },
          { x: rectangle.left + rectangle.width, y: rectangle.top }
        ];

        const rectangleVertices = _.map(rectangleOriginalVertices, rotatePoint);

        rectangleArea /= 1000;

        return _.some(points, function (point) {
          let trianglesArea = 0;

          for (let i = 0; i < 4; i++) {
            const A = rectangleVertices[i];
            const B = rectangleVertices[i < 3 ? i + 1 : 0];

            trianglesArea += getTriangleArea(A, B, point);
          }

          trianglesArea = Math.floor(trianglesArea / 1000);
          return trianglesArea > rectangleArea;
        });

        function rotatePoint (point) {
          const x = Math.round((Math.cos(radiansAngle) * (point.x - pivot.x)) -
                (Math.sin(radiansAngle) * (point.y - pivot.y)) + pivot.x);

          const y = Math.round((Math.sin(radiansAngle) * (point.x - pivot.x)) +
                (Math.cos(radiansAngle) * (point.y - pivot.y)) + pivot.y);

          return { x, y };
        }

        function getTriangleArea (A, B, C) {
          const abx = A.x - B.x;
          const bcx = B.x - C.x;
          const cax = C.x - A.x;

          const aby = A.y - B.y;
          const bcy = B.y - C.y;
          const cay = C.y - A.y;

          const a = Math.sqrt(abx * abx + aby * aby);
          const b = Math.sqrt(bcx * bcx + bcy * bcy);
          const c = Math.sqrt(cax * cax + cay * cay);

          const s = (a + b + c) / 2;
          return Math.sqrt(s * (s - a) * (s - b) * (s - c));
        }
      }
    }
  }

  destruct () {
    INKIVE.GestureAbstract.prototype.destruct.call(this);

    const that = this;
    const canvas = that.canvas;
    const selectedElements = canvas.getSelectedElems();
    const selected = selectedElements[0];

    canvas.setMode('select');
    canvas.recalculateAllSelectedDimensions();
    canvas.call('editor.changed', selectedElements);
    canvas.runExtensions('endRotate', { elem: selected });

    INKIVE.DesignFacade.trigger('rotate');
  }
}
